import * as React from 'react';
import { cn } from '@/lib/utils';

// Icon definitions with viewBox, pre-computed aspectRatio, and paths
const ICONS_BASE = {
  core: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M191.111 236.955C193.297 240.794 191.966 245.703 188 247.65C170.412 256.283 151.071 260.86 131.411 260.997C109.079 261.153 87.0799 255.575 67.5201 244.797C47.9602 234.019 31.4936 218.401 19.6959 199.439C7.89816 180.477 1.16416 158.804 0.138254 136.495C-0.887656 114.186 3.82885 91.9864 13.8364 72.0214C23.844 52.0564 38.8079 34.9937 57.296 22.466C75.7841 9.93833 97.1779 2.36491 119.43 0.470429C139.021 -1.19742 158.699 1.58536 177.006 8.56755C181.134 10.1421 182.91 14.9079 181.085 18.9319L168.95 45.6972C167.125 49.7212 162.393 51.4655 158.216 50.0268C147.027 46.1735 135.129 44.686 123.28 45.6947C108.768 46.9303 94.8145 51.8697 82.7565 60.0402C70.6985 68.2108 60.9391 79.3391 54.4122 92.3603C47.8852 105.381 44.8091 119.86 45.4782 134.41C46.1473 148.96 50.5392 163.095 58.2337 175.462C65.9282 187.829 76.6677 198.015 89.4247 205.044C102.182 212.074 116.529 215.712 131.094 215.61C142.986 215.527 154.697 212.954 165.484 208.09C169.512 206.274 174.384 207.577 176.57 211.416L191.111 236.955Z',
        fill: 'currentColor',
      },
      {
        d: 'M199.723 29.4335C202.22 25.7883 207.216 24.8381 210.701 27.5534C217.756 33.0495 224.227 39.2564 230.013 46.076C232.871 49.4452 232.13 54.4767 228.592 57.1232L205.06 74.7264C201.522 77.3729 196.535 76.6207 193.568 73.3467C190.899 70.4018 188.028 67.6474 184.974 65.1038C181.579 62.276 180.62 57.3247 183.116 53.6795L199.723 29.4335Z',
        fill: '#009688',
      },
      {
        d: 'M239.858 75.3006C243.803 73.3097 248.639 74.8848 250.384 78.9436C256.021 92.0506 259.47 105.994 260.594 120.217C260.942 124.622 257.399 128.27 252.981 128.347L223.598 128.864C219.18 128.941 215.575 125.415 215.083 121.024C214.255 113.63 212.46 106.376 209.746 99.4485C208.134 95.3348 209.679 90.5339 213.623 88.543L239.858 75.3006Z',
        fill: '#009688',
      },
      {
        d: 'M251.479 149.743C255.843 150.437 258.842 154.545 257.882 158.858C252.129 184.703 238.645 208.194 219.228 226.195C215.988 229.199 210.929 228.681 208.129 225.263L189.505 202.529C186.706 199.111 187.238 194.096 190.378 190.988C201.305 180.171 209.1 166.591 212.93 151.7C214.03 147.421 218.093 144.433 222.456 145.127L251.479 149.743Z',
        fill: '#009688',
      },
      {
        d: 'M163.363 76.5632C167.503 79.0431 171.254 81.9249 174.597 85.1283C171.783 90.4257 171.678 97.0101 174.898 102.588C178.32 108.515 184.605 111.76 190.998 111.584C194.329 122.178 194.855 133.619 192.275 144.69C185.401 143.945 178.414 147.216 174.735 153.588C170.889 160.251 171.787 168.35 176.38 173.976C168.467 182.223 158.594 187.979 147.956 190.943C145.469 183.982 138.818 179 131.002 179C123.197 179 116.552 183.968 114.057 190.915C108.825 189.438 103.7 187.252 98.8129 184.324C94.0634 181.479 89.8263 178.105 86.1302 174.323C90.9743 168.687 91.9919 160.39 88.0656 153.589C84.2812 147.034 76.9965 143.76 69.9357 144.764C67.396 133.924 67.72 122.406 71.2133 111.435C78.2229 112.366 85.4248 109.093 89.18 102.589C92.6389 96.5973 92.2613 89.4443 88.8109 83.9727C96.1052 77.3316 104.774 72.6067 114.027 69.9969C116.497 76.9893 123.164 82.0001 131.002 82.0002C138.862 82.0002 145.544 76.9615 147.998 69.9384C153.272 71.4158 158.438 73.613 163.363 76.5632ZM141.593 112.907C131.908 107.105 119.353 110.253 113.551 119.939C107.75 129.624 110.898 142.179 120.583 147.98C130.269 153.782 142.823 150.634 148.625 140.948C154.427 131.263 151.278 118.709 141.593 112.907Z',
        fill: '#009688',
      },
    ],
  },
  chat: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      { d: 'M261 86V131L45 131L45 86L261 86Z', fill: '#009688' },
      {
        d: 'M163 216H0V171H261V216H216V261L163 216Z',
        fill: 'currentColor',
      },
      { d: 'M261 45H0V0H261V45Z', fill: 'currentColor' },
    ],
  },
  iq: {
    viewBox: '0 0 261 262',
    aspectRatio: 261 / 262,
    paths: [
      {
        d: 'M45 216H163L202 262L35 261H0V69H45V216Z',
        fill: 'currentColor',
      },
      {
        d: 'M240 0V222L195 168.5V45H65V0H240Z',
        fill: 'currentColor',
      },
      { d: 'M261 262H216L136 169H181L261 262Z', fill: '#009688' },
      { d: 'M45 45H0V0H45V45Z', fill: '#009688' },
    ],
  },
  crm: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M130.5 0C161.718 0 190.375 10.9634 212.834 29.248C205.359 46.791 192.476 61.4745 176.276 71.2051C163.694 61.6632 148.009 56 131 56C113.598 56 97.5798 61.9275 84.8545 71.873C68.3124 62.2623 55.1131 47.5331 47.4258 29.8525C69.9932 11.2043 98.9382 0 130.5 0Z',
        fill: 'currentColor',
      },
      {
        d: 'M29.8526 47.4258C47.5331 55.1131 62.2623 68.3124 71.8731 84.8545C61.9275 97.5798 56 113.598 56 131C56 148.009 61.6632 163.694 71.2051 176.276C61.4745 192.476 46.791 205.359 29.2481 212.834C10.9634 190.375 1.52588e-05 161.718 1.52588e-05 130.5C1.52588e-05 98.9382 11.2043 69.9932 29.8526 47.4258Z',
        fill: 'currentColor',
      },
      {
        d: 'M84.8545 190.126C97.5799 200.072 113.597 206 131 206C148.009 206 163.694 200.336 176.276 190.794C192.247 200.387 204.995 214.795 212.515 232.011C190.104 250.14 161.571 261 130.5 261C99.0886 261 70.2703 249.901 47.75 231.412C55.4812 214.058 68.5421 199.603 84.8545 190.126Z',
        fill: '#009688',
      },
      {
        d: 'M178 131C178 156.957 156.957 178 131 178C105.043 178 84 156.957 84 131C84 105.043 105.043 84 131 84C156.957 84 178 105.043 178 131Z',
        fill: '#009688',
      },
    ],
  },
  mark: {
    viewBox: '0 0 24 24',
    aspectRatio: 1, // 24/24
    paths: [
      {
        d: 'M17.6855 7.8359H6.2825V4.8445H3.4402V19.1555H6.2825V16.147H17.6855V19.1555H20.5277V4.8445H17.6855V7.8528V7.8359ZM6.2825 13.5466V10.4363H17.6855V13.5466H6.2825Z',
        fill: 'currentColor',
      },
    ],
  },
  humain: {
    viewBox: '0 0 103 16',
    aspectRatio: 6.4375, // 103/16
    paths: [
      {
        d: 'M99.6806 15.6863H102.504V0H99.3684V10.8235L89.6368 0H86.8136V15.6863H89.9557V4.86275L99.6806 15.6863Z',
        fill: 'currentColor',
        fillRule: 'evenodd' as const,
      },
      { d: 'M82.83 0H79.6926V15.6863H82.83V0Z', fill: 'currentColor' },
      {
        d: 'M62.88 15.6863H59.552L65.9821 0H70.6918L77.1219 15.6863H73.7342L72.4455 12.549H64.1686L62.88 15.6863ZM65.3245 9.72549H71.2896L68.4665 2.82353H68.1476L65.3245 9.72549Z',
        fill: 'currentColor',
        fillRule: 'evenodd' as const,
      },
      {
        d: 'M44.121 0H41.2912V15.6863H44.4332V4.70588H44.4929C44.4929 4.70588 44.8052 5.70981 45.3764 6.46275L47.5685 9.41177H50.7038L52.9026 6.46275C53.4672 5.70981 53.7794 4.70588 53.7794 4.70588H53.8459V15.6863H56.9813V0H54.1581L49.2624 6.58824H49.0432L44.121 0Z',
        fill: 'currentColor',
        fillRule: 'evenodd' as const,
      },
      {
        d: 'M29.7792 13.0196C27.2417 13.0196 25.3884 10.9804 25.3884 8.15686V0H22.2531V8.15686C22.2531 12.6745 25.4548 16 29.7792 16C34.1103 16 37.3121 12.6745 37.3121 8.15686V0H34.1701V8.15686C34.1701 10.9804 32.3234 13.0196 29.7792 13.0196Z',
        fill: 'currentColor',
        fillRule: 'evenodd' as const,
      },
      {
        d: 'M3.14199 3.71242H15.1321V0H18.2675V15.6863H15.1321V11.9739H3.14199V15.6863H0V0H3.14199V3.71242ZM3.14199 9.15033H15.1321V6.53595H3.14199V9.15033Z',
        fill: 'currentColor',
        fillRule: 'evenodd' as const,
      },
    ],
  },
  'brain-wordmark': {
    viewBox: '0 0 85 16',
    aspectRatio: 5.3125, // 85/16
    paths: [
      {
        d: 'M-0.00039053 16V0H10.5596C13.4396 0 15.3596 1.92 15.3596 4.8C15.3596 6.048 14.8156 7.104 13.9196 7.808C15.2316 8.48 15.9996 9.664 15.9996 11.2C15.9996 14.08 14.0796 16 11.1996 16H-0.00039053ZM3.19961 9.44V13.12H11.1996C12.1596 13.12 12.7996 12.48 12.7996 11.52V11.04C12.7996 10.08 12.1596 9.44 11.1996 9.44H3.19961ZM3.19961 6.56H10.5596C11.5196 6.56 12.1596 5.92 12.1596 4.96V4.48C12.1596 3.52 11.5196 2.88 10.5596 2.88H3.19961V6.56ZM20.1559 16V0H31.6759C34.5559 0 36.4759 1.92 36.4759 4.8C36.4759 7.36 34.8119 9.152 32.2839 9.408C32.5079 9.664 32.7319 9.952 32.8599 10.176L36.4759 16H32.8599L28.7959 9.44H23.3559V16H20.1559ZM23.3559 6.56H31.6759C32.6359 6.56 33.2759 5.92 33.2759 4.96V4.48C33.2759 3.52 32.6359 2.88 31.6759 2.88H23.3559V6.56ZM42.5766 16H39.1846L45.7446 0H50.5446L57.1046 16H53.6486L52.3366 12.8H43.8886L42.5766 16ZM45.0726 9.92H51.1526L48.2726 2.88H47.9526L45.0726 9.92ZM63.6684 16H60.4684V0H63.6684V16ZM81.5884 16L71.6684 4.96V16H68.4684V0H71.3484L81.2684 11.04V0H84.4684V16H81.5884Z',
        fill: 'currentColor',
      },
    ],
  },
  os: {
    viewBox: '0 0 34 16',
    aspectRatio: 2.125, // 34/16
    paths: [
      {
        d: 'M25.7494 13.2308C23.1715 13.2308 21.443 12.3692 21.443 11.0769H18.3713C18.3713 14.0308 21.3245 16 25.7494 16C30.5496 16 33.1373 14.2462 33.1373 10.9846C33.1373 7.84616 30.9842 6.46154 25.9074 6.46154C22.9838 6.46154 21.7491 6.00001 21.7491 4.83078C21.7491 3.47693 23.1418 2.76923 25.7494 2.76923C28.1495 2.76923 29.7495 3.63077 29.7495 4.92308H32.8311C32.8311 1.96923 29.9965 0 25.7494 0C21.1368 0 18.6774 1.69232 18.6774 4.83078C18.6774 7.93847 20.7714 9.23077 25.6309 9.23077C28.7026 9.23077 30.0557 9.75386 30.0557 10.9846C30.0557 12.4308 28.5544 13.2308 25.7494 13.2308Z',
        fill: 'currentColor',
        fillRule: 'evenodd' as const,
      },
      {
        d: 'M8.00045 0C3.3879 0 0 3.38462 0 8C0 12.6154 3.3879 16 8.00045 16C12.613 16 16.0008 12.6154 16.0008 8C16.0008 3.38462 12.613 0 8.00045 0ZM8.00045 13.0769C5.22502 13.0769 3.22979 10.9231 3.22979 8C3.22979 5.07692 5.22502 2.92308 8.00045 2.92308C10.766 2.92308 12.771 5.07692 12.771 8C12.771 10.9231 10.766 13.0769 8.00045 13.0769Z',
        fill: 'currentColor',
        fillRule: 'evenodd' as const,
      },
    ],
  },
  'saudi-riyal': {
    viewBox: '0 0 24 24',
    aspectRatio: 1, // 24/24
    paths: [
      {
        d: 'M20 10L4 13.5M2.97803 19.351L8.52703 17.988C8.95999 17.8699 9.34067 17.6097 9.60784 17.2491C9.87501 16.8885 10.0131 16.4486 10 16V2M14.5 4V15.22C14.5 15.3719 14.5347 15.5218 14.6013 15.6583C14.6679 15.7948 14.7648 15.9143 14.8845 16.0078C15.0042 16.1013 15.1436 16.1663 15.2922 16.1979C15.4408 16.2295 15.5946 16.2268 15.742 16.19L20 15.2M20 19.5L14.5 20.7',
        stroke: 'currentColor',
        strokeWidth: 1.5,
        strokeLinecap: 'round' as const,
        strokeLinejoin: 'round' as const,
        fill: 'none',
      },
    ],
  },
  'code-wordmark': {
    viewBox: '0 0 71 16',
    aspectRatio: 4.4375, // 71/16
    paths: [
      {
        d: 'M14 2.88H8C5.12 2.88 3.2 4.8 3.2 8C3.2 11.2 5.12 13.12 8 13.12H14V16H8C3.2 16 0 12.8 0 8C0 3.2 3.2 0 8 0H14V2.88ZM26 0C21.39 0 18 3.38 18 8C18 12.62 21.39 16 26 16C30.61 16 34 12.62 34 8C34 3.38 30.61 0 26 0ZM26 13.08C23.23 13.08 21.23 10.92 21.23 8C21.23 5.08 23.23 2.92 26 2.92C28.77 2.92 30.77 5.08 30.77 8C30.77 10.92 28.77 13.08 26 13.08ZM38 0H46C50.8 0 54 3.2 54 8C54 12.8 50.8 16 46 16H38V0ZM41.2 2.88V13.12H46C48.88 13.12 50.8 11.2 50.8 8C50.8 4.8 48.88 2.88 46 2.88H41.2ZM58 0H70.8V2.88H61.2V6.56H70.8V9.44H61.2V13.12H70.8V16H58V0Z',
        fill: 'currentColor',
        fillRule: 'evenodd' as const,
      },
    ],
  },
  'fabric-wordmark': {
    viewBox: '0 0 101 16',
    aspectRatio: 6.3125, // 101/16
    paths: [
      {
        d: 'M0 0H12.8V2.88H3.2V6.56H12.8V9.44H3.2V16H0V0ZM20.2 16H16.8L23.36 0H28.16L34.72 16H31.27L29.96 12.8H21.51L20.2 16ZM22.69 9.92H28.77L25.89 2.88H25.57L22.69 9.92ZM38.72 16V0H49.28C52.16 0 54.08 1.92 54.08 4.8C54.08 6.048 53.54 7.104 52.64 7.808C53.95 8.48 54.72 9.664 54.72 11.2C54.72 14.08 52.8 16 49.92 16H38.72ZM41.92 9.44V13.12H49.92C50.88 13.12 51.52 12.48 51.52 11.52V11.04C51.52 10.08 50.88 9.44 49.92 9.44H41.92ZM41.92 6.56H49.28C50.24 6.56 50.88 5.92 50.88 4.96V4.48C50.88 3.52 50.24 2.88 49.28 2.88H41.92V6.56ZM58.72 16V0H70.24C73.12 0 75.04 1.92 75.04 4.8C75.04 7.36 73.37 9.15 70.84 9.41C71.07 9.66 71.29 9.95 71.42 10.18L75.04 16H71.42L67.36 9.44H61.92V16H58.72ZM61.92 6.56H70.24C71.2 6.56 71.84 5.92 71.84 4.96V4.48C71.84 3.52 71.2 2.88 70.24 2.88H61.92V6.56ZM82.24 16H79.04V0H82.24V16ZM100.24 2.88H94.24C91.36 2.88 89.44 4.8 89.44 8C89.44 11.2 91.36 13.12 94.24 13.12H100.24V16H94.24C89.44 16 86.24 12.8 86.24 8C86.24 3.2 89.44 0 94.24 0H100.24V2.88Z',
        fill: 'currentColor',
        fillRule: 'evenodd' as const,
      },
    ],
  },
  'create-wordmark': {
    viewBox: '0 0 107 16',
    aspectRatio: 6.6875, // 107/16
    paths: [
      {
        d: 'M14 2.88H8C5.12 2.88 3.2 4.8 3.2 8C3.2 11.2 5.12 13.12 8 13.12H14V16H8C3.2 16 0 12.8 0 8C0 3.2 3.2 0 8 0H14V2.88ZM18 16V0H29.52C32.4 0 34.32 1.92 34.32 4.8C34.32 7.36 32.65 9.15 30.12 9.41C30.35 9.66 30.57 9.95 30.7 10.18L34.32 16H30.7L26.64 9.44H21.2V16H18ZM21.2 6.56H29.52C30.48 6.56 31.12 5.92 31.12 4.96V4.48C31.12 3.52 30.48 2.88 29.52 2.88H21.2V6.56ZM38.32 0H51.12V2.88H41.52V6.56H51.12V9.44H41.52V13.12H51.12V16H38.32V0ZM58.52 16H55.12L61.68 0H66.48L73.04 16H69.59L68.28 12.8H59.83L58.52 16ZM61.01 9.92H67.09L64.21 2.88H63.89L61.01 9.92ZM77.04 0H90.04V2.88H85.14V16H81.94V2.88H77.04V0ZM94.04 0H106.84V2.88H97.24V6.56H106.84V9.44H97.24V13.12H106.84V16H94.04V0Z',
        fill: 'currentColor',
        fillRule: 'evenodd' as const,
      },
    ],
  },
  create: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      { d: 'M261 91H215.647L153 242H198.353L261 91Z', fill: '#009688' },
      { d: 'M215 63H45V197H159L140 242H0V18H215V63Z', fill: 'currentColor' },
    ],
  },
  fabric: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M32.2168 219H0V174H32.2168V219ZM87.1367 219H42.7031V174H87.1367V219ZM261 219H97.623V174H261V219ZM173 0H218V261H173V0Z',
        fill: '#009688',
      },
      {
        d: 'M163.377 86.7031H0V41.7031H163.377V86.7031ZM217.297 86.7031H173.863V41.7031H217.297V86.7031ZM261 86.7031H227.783V41.7031H261V86.7031ZM42 0H87V261H42V0Z',
        fill: 'currentColor',
      },
    ],
  },
  one: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M53 242H1V190H53V242ZM260.914 242H208.914V190H260.914V242ZM53 156H1V104H53V156ZM260.914 156H208.914V104H260.914V156ZM53 70H1V18H53V70ZM260.914 70H208.914V18H260.914V70Z',
        fill: 'currentColor',
      },
      { d: 'M157 242H105V70H77L105 18H157V242Z', fill: '#009688' },
    ],
  },
  voice: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M147.566 195.681H113.436V64.1768H147.566V195.681ZM96.3691 151.511H62.2383V108.346H96.3691V151.511ZM198.762 151.511H164.631V108.346H198.762V151.511Z',
        fill: '#009688',
      },
      {
        d: 'M45.1729 242.861H0V18H45.1729V242.861ZM261 242.861H215.826V18H261V242.861Z',
        fill: 'currentColor',
      },
    ],
  },
  node: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M152.25 0C152.25 60.06 200.939 108.75 261 108.75V152.25C200.939 152.25 152.25 200.939 152.25 261H108.75C108.75 200.939 60.061 152.25 0 152.25V108.75C60.061 108.75 108.75 60.061 108.75 0H152.25ZM130.5 78.459C117.665 99.762 99.762 117.665 78.46 130.5C99.762 143.335 117.665 161.237 130.5 182.539C143.335 161.237 161.237 143.335 182.539 130.5C161.237 117.665 143.335 99.762 130.5 78.459Z',
        fill: 'currentColor',
        fillRule: 'evenodd',
      },
      {
        d: 'M130.022 105.372C123.519 115.129 115.129 123.52 105.372 130.022C115.129 136.525 123.519 144.915 130.022 154.672C136.524 144.915 144.915 136.525 154.672 130.022C144.915 123.52 136.524 115.129 130.022 105.372Z',
        fill: '#009688',
      },
    ],
  },
  maestro: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M87.888 55.644V87.472L53.739 121.622H0V84.336H60.083L23.875 48.128L52.123 19.88L87.888 55.644ZM237.124 48.128L200.916 84.336H261V121.622H207.734L172.225 86.112V56.531L208.876 19.879L237.124 48.128ZM130.736 216.849L150.03 197.555V260.112H110.082V196.195L130.736 216.849ZM150.031 63.918L130.736 44.624L110.082 65.278V0H150.031V63.918ZM261 177.9H200.916L237.124 214.108L208.876 242.357L172.225 205.706V175.361L206.973 140.614H261V177.9ZM87.888 174V206.591L52.123 242.356L23.875 214.108L60.083 177.9H0V140.614H54.501L87.888 174Z',
        fill: 'currentColor',
      },
      {
        d: 'M130.737 80.608L180.866 130.737L130.737 180.866L80.608 130.737L130.737 80.608Z',
        fill: '#009688',
      },
    ],
  },
  ignite: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M129.88 0C134.06 15.613 139.067 22.524 158.263 28.383C142.755 33.685 136.01 39.235 129.88 56.766C123.357 37.902 116.298 33.017 101.498 28.383C118.212 21.265 124.77 15.293 129.88 0ZM107.055 71.876H153.487V197.581H107.055V71.876Z',
        fill: '#009688',
      },
      {
        d: 'M153.486 261H107.055V214.568H153.486V261ZM78.744 173.8V212.304H40.24V173.799L78.744 173.8ZM220.305 173.8V212.304H181.801V173.799L220.305 173.8ZM67.42 153.414H4.001V114.91H67.42V153.414ZM256.543 153.414H193.124V114.91H256.543V153.414ZM78.744 94.525H40.24V56.021H78.744V94.525ZM220.305 94.525H181.801V56.021H220.305V94.525Z',
        fill: 'currentColor',
      },
    ],
  },
  crew: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M261 257.089H210.154V89.531C210.154 78.486 219.109 69.532 230.154 69.532H261V257.089ZM235.013 4A25.987 25.987 0 1 1 235.013 55.974A25.987 25.987 0 0 1 235.013 4ZM50.844 257.089H0V69.532H30.844C41.889 69.532 50.844 78.486 50.844 89.532V257.089ZM25.987 4A25.987 25.987 0 1 1 25.987 55.974A25.987 25.987 0 0 1 25.987 4Z',
        fill: 'currentColor',
      },
      {
        d: 'M105.078 125.168C105.078 111.914 115.824 101.168 129.078 101.168H131.922C145.177 101.168 155.922 111.914 155.922 125.168V257.09H105.078V125.168ZM157.052 61.623A25.987 25.987 0 1 1 105.078 61.623A25.987 25.987 0 0 1 157.052 61.623Z',
        fill: '#009688',
      },
    ],
  },
  grc: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M74.911 241.191C30.635 227.792 5 181.345 5 142.734V137.491H74.911V241.191ZM256.678 137.491V142.734C256.678 181.345 231.043 227.792 186.767 241.191V137.491H256.678ZM67.92 111.857H5V37.285H67.92V111.857ZM256.68 111.857H193.76V37.285H256.68V111.857Z',
        fill: 'currentColor',
      },
      {
        d: 'M107.536 0H154.143V46.607H107.536V0ZM107.536 75.737H154.143V261H107.536V75.737Z',
        fill: '#009688',
      },
    ],
  },
  infrastructure: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M164.002 191.399H95.002V157.76H164.002V191.399ZM164.002 147.32H95.002V113.681H164.002V147.32ZM164.002 103.239H95.002V69.6H164.002V103.239Z',
        fill: '#009688',
      },
      {
        d: 'M261 245C261 253.837 253.837 261 245 261H16C7.164 261 0 253.837 0 245V208.8H261V245ZM69 191.4H0V139.2H69V191.4ZM261 191.4H192V139.2H261V191.4ZM69 121.8H0V69.6H69V121.8ZM261 121.8H192V69.6H261V121.8ZM245 0C253.837 0 261 7.163 261 16V52.2H0V16C0 7.163 7.163 0 16 0H245Z',
        fill: 'currentColor',
      },
    ],
  },
  health: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M113.303 225.535C138.29 131.464 92.064 137.554 46.825 163.206C27.119 174.38 0 161.504 0 138.85C0 124.149 11.917 112.232 26.618 112.232H35.407C80.366 120.329 103.655 132.85 139.605 177.403L113.303 225.535ZM147.698 225.535C122.71 131.464 168.937 137.554 214.176 163.206C233.882 174.38 261 161.504 261 138.85C261 124.149 249.083 112.232 234.383 112.232H225.593C180.634 120.329 157.345 132.85 121.396 177.403L147.698 225.535ZM129.488 81.884A38.442 38.442 0 1 1 129.488 5A38.442 38.442 0 0 1 129.488 81.884Z',
        fill: '#009688',
      },
      {
        d: 'M129.489 256.525C150.719 256.525 167.93 239.314 167.93 218.083C167.93 138.165 96.105 101.746 24.279 111.862C63.733 118.944 91.047 144.235 91.047 188.746V218.083C91.047 239.314 108.258 256.525 129.489 256.525Z',
        fill: 'currentColor',
      },
    ],
  },
  'ai-transcribe': {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M0 18H45V63H0V18ZM0 198H45V243H0V198ZM90 108H127C131.418 108 135 111.582 135 116V144C135 148.418 131.418 152 127 152H90V108ZM0 116C0 111.582 3.582 108 8 108H45V153H8C3.582 153 0 149.418 0 145V116ZM45 71C45 66.582 48.582 63 53 63H82C86.418 63 90 66.582 90 71V108H45V71ZM45 153H90V190C90 194.418 86.418 198 82 198H53C48.582 198 45 194.418 45 190V153Z',
        fill: 'currentColor',
      },
      {
        d: 'M261 18V63H135.5V18H261ZM261 108V153H176V108H261ZM261 198V243H135.5V198H261Z',
        fill: '#009688',
      },
    ],
  },
  'ai-physician': {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M211.428 121.053C211.428 76.111 174.995 39.679 130.053 39.679C85.112 39.679 48.679 76.112 48.679 121.053V217.321C48.679 219.53 50.47 221.321 52.679 221.321H116.558C127.515 221.321 136.397 230.203 136.397 241.16C136.397 252.118 127.515 261 116.558 261H36.775C21.435 261 9 248.565 9 233.225V121.053C9 54.197 63.197 0 130.053 0C196.909 0 251.107 54.197 251.107 121.053C251.107 171.964 219.685 215.488 175.251 233.381C165.087 237.474 153.529 232.553 149.436 222.389C145.344 212.225 150.265 200.668 160.429 196.575C190.359 184.523 211.428 155.224 211.428 121.053Z',
        fill: 'currentColor',
      },
      {
        d: 'M138.598 72.471C143.568 72.471 147.598 76.5 147.598 81.471V111.606H177.732C182.703 111.606 186.732 115.637 186.732 120.607V137.694C186.732 142.665 182.703 146.694 177.732 146.694H147.598V176.83C147.598 181.8 143.568 185.83 138.598 185.83H121.51C116.539 185.83 112.51 181.801 112.51 176.83V146.694H82.373C77.403 146.694 73.373 142.665 73.373 137.694V120.606C73.373 115.636 77.403 111.606 82.373 111.606H112.51V81.471C112.51 76.5 116.539 72.471 121.51 72.471H138.598Z',
        fill: '#009688',
      },
    ],
  },
  eyenai: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M126.846 84.664C151.622 85.292 171.514 105.574 171.514 130.501C171.514 155.824 150.985 176.353 125.662 176.353C100.339 176.353 79.811 155.824 79.811 130.501C79.811 105.178 100.339 84.648 125.662 84.648L126.846 84.664ZM125.662 116.649A13.852 13.852 0 1 0 125.662 144.353A13.852 13.852 0 0 0 125.662 116.649ZM148.784 0A27.433 27.433 0 1 1 148.784 54.865A27.433 27.433 0 0 1 148.784 0ZM231.081 102.676A27.433 27.433 0 1 1 231.081 157.541A27.433 27.433 0 0 1 231.081 102.676ZM148.784 206.135A27.433 27.433 0 1 1 148.784 261A27.433 27.433 0 0 1 148.784 206.135Z',
        fill: '#009688',
        fillRule: 'evenodd',
      },
      {
        d: 'M82.158 15.315C92.862 11.254 103.324 19.961 103.324 31.409C103.324 39.73 97.619 46.824 90.023 50.221C59.523 63.86 38.271 94.466 38.271 130.037C38.271 165.609 59.523 196.215 90.023 209.854C97.619 213.251 103.324 220.344 103.324 228.665C103.324 240.113 92.862 248.82 82.158 244.759C35.888 227.204 3 182.462 3 130.037C3 77.613 35.888 32.87 82.158 15.315ZM211.028 148.825C216.035 154.187 223.166 157.541 231.081 157.541C236.658 157.541 241.844 155.874 246.174 153.016C238.55 193.242 211.287 226.515 174.731 242.489C175.693 239.692 176.217 236.691 176.217 233.568C176.217 223.214 170.48 214.201 162.013 209.532C186.627 198.258 205.099 175.89 211.028 148.825ZM174.326 17.408C211.134 33.333 238.595 66.773 246.204 107.22C241.868 104.35 236.67 102.677 231.081 102.677C223.179 102.677 216.059 106.019 211.054 111.365C205.223 84.576 187.107 62.373 162.903 50.955C170.88 46.157 176.217 37.419 176.217 27.433C176.217 23.895 175.546 20.513 174.326 17.408Z',
        fill: 'currentColor',
      },
    ],
  },
  code: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M92.932 64.488H44.488V196.966H92.932V241.454H0V20H92.932V64.488ZM261 241.454H168.068V196.966H216.512V64.488H168.068V20H261V241.454Z',
        fill: 'currentColor',
      },
      {
        d: 'M189.818 86.239V117.875H69.205V86.239H189.818ZM189.818 143.58V175.216H69.205V143.58H189.818Z',
        fill: '#009688',
      },
    ],
  },
  marketplace: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M88.627 235.64A24.832 25.36 0 1 1 38.963 235.64A24.832 25.36 0 0 1 88.627 235.64ZM217.541 235.64A25.36 25.36 0 1 1 166.82 235.64A25.36 25.36 0 0 1 217.541 235.64ZM109.516 0V52.834H71.331V134.912C71.331 139.33 74.913 142.912 79.331 142.912H240.789V158.147C240.789 178.859 224.039 193.372 203.378 193.372H53C35.327 193.372 21 179.045 21 161.372V19C21 8.507 29.507 0 40 0H109.516Z',
        fill: 'currentColor',
      },
      { d: 'M143.575 89.982H240.789V142.816H143.575V89.982Z', fill: '#009688' },
    ],
  },
  brain: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M122.961 261H70.761V208.8H122.961V261ZM52.2 156.6V208.8H0V156.6H52.2ZM122.961 156.6H70.761V104.4H122.961V156.6ZM52.2 104.4H0V52.2H52.2V104.4ZM122.961 52.2H70.761V0H122.961V52.2Z',
        fill: 'currentColor',
      },
      {
        d: 'M141.52 0V51.791H186.271V104.006H141.52V259.84H186.271V218.232H224.866C228.732 218.232 231.866 215.098 231.866 211.232V154.545H254.225C259.058 154.545 261.908 149.124 259.168 145.143L228.349 100.375C227.89 99.708 227.645 98.889 227.64 98.079C227.064 12.612 168.407 0 141.52 0Z',
        fill: '#009688',
      },
    ],
  },
  models: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M5 0H50C62.15 0 72 9.85 72 22V239C72 251.15 62.15 261 50 261H5V0ZM182 113C182 103.611 190.046 96 199.971 96H238.029C247.954 96 256 103.611 256 113V149C256 158.389 247.954 166 238.029 166H199.971C190.046 166 182 158.389 182 149V113Z',
        fill: 'currentColor',
      },
      {
        d: 'M256 64C256 72.837 248.837 80 240 80H199.457C191.536 80 183.937 83.133 178.317 88.715L175.859 91.155C170.189 96.787 167 104.449 167 112.441V148.391C167 156.383 170.189 164.044 175.859 169.676L178.485 172.285C184.106 177.867 191.705 181 199.627 181H240C248.837 181 256 188.163 256 197V245C256 253.837 248.837 261 240 261H192C183.163 261 176 253.837 176 245V203.446C176 195.454 172.811 187.792 167.14 182.16L163.671 178.714C158.051 173.132 150.451 170 142.53 170H103C94.163 170 87 162.837 87 154V106C87 97.163 94.163 90 103 90H143.368C151.29 90 158.89 86.867 164.51 81.285L167.141 78.671C172.811 73.039 176 65.378 176 57.386V16C176 7.163 183.163 0 192 0H240C248.837 0 256 7.163 256 16V64Z',
        fill: '#009688',
      },
    ],
  },
  connect: {
    viewBox: '0 0 261 261',
    aspectRatio: 1,
    paths: [
      {
        d: 'M131.5 0C194.846 0 247.648 45.135 259.507 105H216.522C211.358 105 206.854 101.654 204.701 96.961C191.982 69.247 163.989 50 131.5 50C87.041 50 51 86.041 51 130.5C51 174.959 87.041 211 131.5 211C162.645 211 189.658 193.313 203.045 167.436C205.31 163.058 209.663 160 214.592 160H258.651C245.28 217.864 193.428 261 131.5 261C59.427 261 1 202.573 1 130.5C1 58.427 59.427 0 131.5 0Z',
        fill: '#009688',
      },
      {
        d: 'M164.609 130.5C164.609 148.787 149.784 163.612 131.497 163.612C113.209 163.612 98.385 148.787 98.385 130.5C98.385 112.213 113.209 97.388 131.497 97.388C149.784 97.388 164.609 112.213 164.609 130.5Z',
        fill: 'currentColor',
      },
    ],
  },
} as const;

const WORDMARKS = {
  'create-wordmark': 'Create',
  'fabric-wordmark': 'Fabric',
  'one-wordmark': 'One',
  'voice-wordmark': 'Voice',
  'node-wordmark': 'Node',
  'maestro-wordmark': 'Maestro',
  'ignite-wordmark': 'Ignite',
  'crew-wordmark': 'Crew',
  'grc-wordmark': 'GRC',
  'infrastructure-wordmark': 'Infrastructure',
  'health-wordmark': 'Health',
  'ai-transcribe-wordmark': 'AI Transcribe',
  'ai-physician-wordmark': 'AI Physician',
  'eyenai-wordmark': 'Eyenai',
  'code-wordmark': 'Code',
  'marketplace-wordmark': 'Marketplace',
  'brain-wordmark': 'Brain',
  'models-wordmark': 'Models',
  'connect-wordmark': 'Connect',
} as const;

const ICONS = {
  ...ICONS_BASE,
  ...Object.fromEntries(
    Object.entries(WORDMARKS).map(([icon, wordmark]) => [
      icon,
      { viewBox: '0 0 240 32', aspectRatio: 7.5, wordmark },
    ]),
  ),
} as typeof ICONS_BASE &
  Record<
    keyof typeof WORDMARKS,
    {
      viewBox: string;
      aspectRatio: number;
      wordmark: string;
    }
  >;

type IconName = keyof typeof ICONS;

// Size to height mapping
const SIZE_MAP = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
  '2xl': 96,
} as const;

type Size = keyof typeof SIZE_MAP | 'fluid';

export interface BrandIconProps extends React.SVGAttributes<SVGSVGElement> {
  /** Icon variant to display */
  icon: IconName;
  /** Size of the icon (height in pixels, width scales proportionally). "fluid" uses 1em height to scale with parent font-size. */
  size?: Size;
}

const BrandIcon = React.forwardRef<SVGSVGElement, BrandIconProps>(
  (
    { icon, size = 'md', className, style, 'aria-label': ariaLabel, ...props },
    ref,
  ) => {
    const iconData = ICONS[icon];
    const isFluid = size === 'fluid';
    const isAccessible = !!ariaLabel;

    const sizeProps = isFluid
      ? { style: { height: '1em', width: 'auto', ...style } }
      : {
          width: Math.round(
            SIZE_MAP[size as keyof typeof SIZE_MAP] * iconData.aspectRatio,
          ),
          height: SIZE_MAP[size as keyof typeof SIZE_MAP],
          style,
        };

    return (
      <svg
        ref={ref}
        {...(isAccessible
          ? { role: 'img', 'aria-label': ariaLabel }
          : { 'aria-hidden': true as const })}
        viewBox={iconData.viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(
          'shrink-0 transition-[color] duration-(--duration-fast) ease-standard motion-reduce:transition-none',
          className,
        )}
        data-slot="icon"
        {...props}
        {...sizeProps}
      >
        {'wordmark' in iconData ? (
          <text
            x="0"
            y="24"
            fill="currentColor"
            fontFamily="'Optician Sans', Inter, sans-serif"
            fontSize="24"
            fontWeight="500"
          >
            {iconData.wordmark}
          </text>
        ) : (
          iconData.paths.map(({ d, ...pathProps }) => (
            <path key={d} d={d} {...pathProps} />
          ))
        )}
      </svg>
    );
  },
);

BrandIcon.displayName = 'BrandIcon';

export type { IconName, Size };
export { BrandIcon, ICONS, SIZE_MAP };
